import React from "react";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
import withReduxProvider from "web/react/redux-provider";
import { gettext } from "web/script/modules/django-i18n";
import userProfiler from "web/script/modules/userprofiler";
import styles from "./oos-save-for-later-section.css";

interface OOSSaveForLaterSectionProps {
    productId: string;
}

export function OOSSaveForLaterSection({ productId }: OOSSaveForLaterSectionProps): JSX.Element {
    // Back in stock alerts
    const title = gettext("oos_product.bis_banner.title");
    // Get notified as soon as this item comes back into stock
    const desc = gettext("oos_product.bis_banner.desc");
    // Notify me
    const cta = gettext("oos_product.bis_banner.cta");

    return (
        <div className={styles.oosS4lContainer}>
            <div className={styles.contentContainer}>
                <span className={styles.title}>{title}</span>
                <span className={styles.desc}>{desc}</span>
                <SaveForLaterButton
                    className={styles.s4lButton}
                    cta={cta}
                    type="stockAlert"
                    pageSource="oos"
                    isLoggedIn={userProfiler.isLoggedIn()}
                    productId={productId}
                />
            </div>
        </div>
    );
}
export default withReduxProvider(OOSSaveForLaterSection);
